// Display only. Never changes precedence, stored facts, eligibility or access.
const text = value => (typeof value === 'string' || typeof value === 'number') && String(value).trim() ? String(value).trim() : 'Not recorded'
export function recordDisplayContext(record) {
  const raw = record?.raw || record || {}
  const basis = {
    confirmed: 'sr_confirmed_date', event: 'sr_event_date', projected: 'sr_projected_date',
    season_year: 'Season/sport estimate, not a stored event date', none: 'No display date available',
  }[record?.dateBasis] || 'Basis not reported'
  return {
    pursuit: text(raw.sr_pursuit_status ?? (!record?.raw ? record?.pursuit : undefined)),
    outcome: text(raw.sr_champion_status ?? (!record?.raw ? record?.championStatus : undefined)),
    basis,
    confidence: text(record?.dateConfidence),
    confirmed: text(raw.sr_confirmed_date ?? record?.confirmedRaw),
    event: text(raw.sr_event_date ?? record?.eventRaw),
    projected: text(raw.sr_projected_date),
  }
}
